import { render, staticRenderFns } from "./AppView.vue?vue&type=template&id=011c3770"
import script from "./AppView.vue?vue&type=script&lang=ts"
export * from "./AppView.vue?vue&type=script&lang=ts"
import style0 from "./AppView.vue?vue&type=style&index=0&id=011c3770&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports